'use client';
import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import React from 'react';
import { useMedia } from 'react-use';
import ApplicationBlock from 'shared/sections/FrAskedQuestions/ApplicationBlock';
import CollapseListItem from 'shared/sections/FrAskedQuestions/CollapseListItem';
import { listCollapseOutstaff } from 'shared/sections/FrAskedQuestions/constants';

import cn from './style.module.sass';

type FrAskedQuestionsProps = {
    current: string;
    isSolution?: boolean;
    title?: string;
};

export default function FrAskedQuestions({ current, isSolution, title }: FrAskedQuestionsProps) {
    const mediaMobile = useMedia('(max-width: 1199px)');
    const listType = current;
    return (
        <ScrollAnimation>
            <FullWrapper smallPaddings={true} isMargin={false} caseName={cn.frAskedQuestions}>
                {isSolution && <h2 className={cn['frAskedQuestions__main-title']}>{title}</h2>}
                <div className={cn['frAskedQuestions__wrapper']}>
                    {!isSolution && (
                        <div className={cn['frAskedQuestions__wrapper-left']}>
                            <h2 className={cn['frAskedQuestions__title']}>FAQ</h2>
                            {!mediaMobile && <ApplicationBlock />}
                        </div>
                    )}
                    <div className={cn['frAskedQuestions__list']}>
                        {listCollapseOutstaff[listType]?.map(el => (
                            <CollapseListItem
                                key={el.title}
                                title={el.title}
                                content={el.content}
                                /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */
                                icon={el?.icon}
                            />
                        ))}
                    </div>
                    {!isSolution && mediaMobile && <ApplicationBlock />}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
}
